import { Link } from 'react-router-dom';
import { colors, fonts, layout } from './theme';

const styles = {
  header: {
    backgroundColor: colors.white,
    paddingTop: '0.01rem',
    paddingBottom: '1rem',
    borderBottom: `thin solid ${colors.gray200}`,
    borderRadius: '0 0 25px 25px',
    boxShadow: '0px 4px 14px 0px rgba(0, 99, 160, 0.10)',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    marginTop: 0,
    marginBottom: '2rem',
  },
  navbar: {
    maxWidth: layout.containerMaxWidth,
    margin: '0 auto',
    padding: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    backgroundImage: 'none',
  },
  logoImage: {
    height: '40px',
    width: 'auto',
    objectFit: 'contain',
    maxWidth: '200px',
  },
  nav: {
    display: 'flex',
    gap: '1.5rem',
    alignItems: 'center',
  },
  navLink: {
    fontFamily: fonts.heading,
    fontSize: '16px',
    fontWeight: 500,
    color: colors.midGray,
    textDecoration: 'none',
    backgroundImage: 'none',
    transition: 'color 0.2s ease',
  },
};

function PortalHeader({ user, showAdminLink = false }) {
  return (
    <header style={styles.header}>
      <div style={styles.navbar}>
        <Link to="/" style={styles.logo} title="Business Initiative">
          <img 
            src="/logo.png" 
            alt="Business Initiative" 
            title="Business Initiative"
            style={styles.logoImage}
            onError={(e) => {
              // Fallback to text if image doesn't load
              e.target.style.display = 'none';
              const parent = e.target.parentNode;
              if (!parent.querySelector('.logo-fallback')) {
                const textSpan = document.createElement('span');
                textSpan.className = 'logo-fallback';
                textSpan.style.fontFamily = fonts.heading;
                textSpan.style.fontSize = '1.25rem';
                textSpan.style.fontWeight = 600;
                textSpan.style.color = colors.darkGray;
                textSpan.textContent = 'Business Initiative';
                parent.appendChild(textSpan);
              }
            }}
          />
        </Link>
        <nav style={styles.nav}>
          {user && (
            <>
              <a
                href="https://businessinitiative.org/contact/"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.navLink}
                onMouseEnter={(e) => (e.target.style.color = colors.darkGray)}
                onMouseLeave={(e) => (e.target.style.color = colors.midGray)}
              >
                Contact
              </a>
              {showAdminLink && (
                <Link
                  to="/admin"
                  style={styles.navLink}
                  onMouseEnter={(e) => (e.target.style.color = colors.darkGray)}
                  onMouseLeave={(e) => (e.target.style.color = colors.midGray)}
                >
                  Admin
                </Link>
              )}
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default PortalHeader;

